import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { useAuth } from '../../auth'
import {
  ChartsWidget3,
  MixedWidget7,
  StatisticsWidget5,
  StatisticsWidget6,
} from '../../../../_metronic/partials/widgets'
import DatePicker from 'react-datepicker'
import { useFetchCommon } from '../../../../_metronic/helpers/crud-helper/useQuery'
import { UsersTable } from '../data-administration/data-admininstration-list/table/UsersTable'
import { roleColumns } from './_columns'
import { UsersListHeader } from '../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { ListViewProvider } from '../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../data-administration/data-admininstration-list/core/QueryRequestProvider'
import {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
} from '../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UserEditModal } from '../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { useListView } from '../data-administration/data-admininstration-list/core/ListViewProvider'
import { useQueryRequest } from '../user-management/users-list/core/QueryRequestProvider'
import ImpactModalCertFormTry from '../data-administration/data-admininstration-list/form-edit-modal/ImpactModalCertFormTry'
import ReactDOM from 'react-dom';


const Menu = () => {
  const numberItems = [
    {
      value: 'totalCo2Savings',
      value_two: 'totalCo2savings',
      name: 'GHG Savings',
      icon: 'GHG_saving',
      color: '#ffffff',
    },
    {
      value: 'totalEnergySavings',
      value_two: 'totalEnergySavings',
      name: 'Energy Saving',
      icon: 'energy_saved',
      color: '#ffffff',
    },
    {
      value: 'totalWaterSavings',
      value_two: 'totalWaterSavings',
      name: 'Water Saving',
      icon: 'waste_saved',
      color: '#ffffff',
    },
    {
      value: 'totalTreeSavings',
      value_two: 'totalTreeSavings',
      name: 'Tress saved',
      icon: 'trees_saved',
      color: '#ffffff',
    },
  ]
  const [data1, setdata1] = useState<any>({})
  const [data2, setdata2] = useState<any>({})
  const [impact, setImpact] = useState({})

  const { response }: any = useQueryResponse()



  const { responseData: impact1 } = useFetchCommon({
    api: `impact`,
    isEnabled: true,
    isDropDown: false,
  })



  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  // const [loading, setLoading] = useState(false)

  const { updateState } = useQueryRequest()



  const [loading, setLoading] = useState(false)
  const [allCustomerIds, setAllCustomerIds] = useState([])




  const datas: any = useQueryResponseData()
  useEffect(() => {
    if (datas?.[0]?.monthlyWastepickers) {
      setImpact(datas)
      setdata1({
        data: Object.values(datas?.[0]?.monthlyWastepickers),
        label: Object.keys(datas?.[0]?.monthlyWastepickers),
      })
    }
    if (datas?.[0]?.monthlyPayment) {
      setdata2({
        data: Object.values(datas?.[0]?.monthlyPayment),
        label: Object.keys(datas?.[0]?.monthlyPayment),
      })
    }
  }, [datas])

  const { responseData: facilityTypeList } = useFetchCommon({
    api: 'users?page=0&size=10&type=CUSTOMER&status=ACTIVE',
    label: ['personalDetails', 'name'],
    isDropDown: true,
  })

  const { setItemIdForUpdate } = useListView()
  const { auth, currentUser, isSupplyChainManager, isFacilityManager }: any = useAuth();

  const searchElements = [
    {
      type: 'select',
      value: 'select',
      options: [{ value: '', label: 'Select one' }, ...facilityTypeList],
      name: 'customerId',
      label: 'Supplier',
    },
    {
      type: 'datePicker',
      name: 'start_date',
      label: 'Start date',
    },
    {
      type: 'datePicker',
      name: 'end_date',
      label: 'End date',
    },
  ]




  useEffect(() => {
    if (facilityTypeList && facilityTypeList.length > 0) {
      const ids = facilityTypeList.map(supplier => supplier.value)
      console.log("All customer IDs:", ids)
      setAllCustomerIds(ids)
    }
  }, [facilityTypeList])






  const handleReset = () => {
    setStartDate('')
    setEndDate('')
  }

  const handleApply = () => {
    setLoading(true);

    if (allCustomerIds.length === 0) {
      console.error("No customer IDs available");
      setLoading(false);
      return;
    }

    // Format dates from YYYY-MM-DD to MM/DD/YYYY
    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    };

    // Get auth token from local storage
    const authData = localStorage.getItem('kt-auth-react-v');
    let token = "";

    if (authData) {
      try {
        const parsedData = JSON.parse(authData);
        token = parsedData.data.token;
      } catch (error) {
        console.error("Error parsing auth data:", error);
      }
    }

    const formattedStartDate = encodeURIComponent(formatDate(startDate));
    const formattedEndDate = encodeURIComponent(formatDate(endDate));
    const customerIdParam = allCustomerIds.join(',');

    const apiUrl = `${process.env.REACT_APP_BASE_API_URL}impact?start_date=${formattedStartDate}&end_date=${formattedEndDate}&customerId=${customerIdParam}`;

    console.log("Making API call to:", apiUrl);

    // Make the fetch request with the authorization header
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        console.log("API response:", data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error calling API:", error);
        setLoading(false);
      });
  };




  const handleCertificate = () => {
    // Format dates from YYYY-MM-DD to MM/DD/YYYY
    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    };

    // Get auth token from local storage
    const authData = localStorage.getItem('kt-auth-react-v');
    let token = "";

    if (authData) {
      try {
        const parsedData = JSON.parse(authData);
        token = parsedData.data.token;
      } catch (error) {
        console.error("Error parsing auth data:", error);
      }
    }

    // Prepare API request parameters
    const formattedStartDate = encodeURIComponent(formatDate(startDate));
    const formattedEndDate = encodeURIComponent(formatDate(endDate));
    const customerIdParam = allCustomerIds.join(',');

    const apiUrl = `${process.env.REACT_APP_BASE_API_URL}impact?start_date=${formattedStartDate}&end_date=${formattedEndDate}&customerId=${customerIdParam}`;

    // Make the API call
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(responseData => {
        // Create a div to render the React component in
        const rootDiv = document.createElement('div');
        rootDiv.id = 'certificate-modal-root';
        document.body.appendChild(rootDiv);
        const modalBackdrop = document.createElement('div');
        modalBackdrop.style.position = 'fixed';
        modalBackdrop.style.top = '0';
        modalBackdrop.style.left = '0';
        modalBackdrop.style.width = '100%';
        modalBackdrop.style.height = '100%';
        modalBackdrop.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        modalBackdrop.style.zIndex = '1000';
        document.body.appendChild(modalBackdrop);



        // Close function for the modal
        const closeModal = () => {
          document.body.removeChild(modalBackdrop);
          ReactDOM.unmountComponentAtNode(rootDiv);
          document.body.removeChild(rootDiv);
        };

        // Create a modal content container with wider width and more height
        // Create a modal content container with your specified dimensions
        const modalContent = document.createElement('div');
        modalContent.style.backgroundColor = 'white';
        modalContent.style.padding = '20px';
        modalContent.style.borderRadius = '5px';
        modalContent.style.minWidth = '1100px';
        modalContent.style.width = 'auto';
        modalContent.style.maxWidth = 'none';
        modalContent.style.margin = '30px auto'; // Added some top margin
        modalContent.style.position = 'absolute';
        modalContent.style.top = '50%';
        modalContent.style.left = '50%';
        modalContent.style.transform = 'translate(-50%, -50%)'; // Center both horizontally and vertically
        modalContent.style.height = '90vh';
        modalContent.style.overflowY = 'auto';
        modalBackdrop.appendChild(modalContent);

        // Close modal when clicking outside
        modalBackdrop.addEventListener('click', (e) => {
          if (e.target === modalBackdrop) {
            closeModal();
          }
        });

        // Render the component into the modal
        ReactDOM.render(
          <ImpactModalCertFormTry
            response={responseData}
            start_date={formatDate(startDate)}
            end_date={formatDate(endDate)}
            onClose={closeModal}
          />,
          modalContent
        );
      })
      .catch(error => {
        console.error("Error fetching certificate data:", error);
        alert("Error loading certificate data. Please try again.");
      });
  };



  return (
    <KTCard addCard={false}>


      {/* {!isFacilityManager && (
        <div className='row g-3 g-xl-8'>
          {numberItems.map((eachitems, eachIndex) => (
            <div key={eachIndex + 1 + ''} className='col-xl-3'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                img={eachitems.icon}
                color={eachitems.color || 'warning'}
                iconColor='primary'
                title={`
             ${impact?.[0]?.[eachitems.value]?.toFixed(
                  [
                    'collectionPoints',
                    'diversionFacilities',
                    'wasteDiverters',
                    'lifeImpacted',
                  ].includes(eachitems.value)
                    ? 0
                    : 2
                ) || ''
                  }
             ${eachitems.value === 'totalEnergySavings'
                    ? 'KwH'
                    : eachitems.value === 'totalWaterSavings'
                      ? 'Liter'
                      : eachitems.value === 'totalTreeSavings'
                        ? 'Nos'
                        : [
                          'collectionPoints',
                          'diversionFacilities',
                          'wasteDiverters',
                          'lifeImpacted',
                          'wastage',
                        ].includes(eachitems.value)
                          ? ''
                          : ' kg'
                  }
           `}
                description={eachitems.name}
              />
            </div>
          ))}
        </div>
      )} */}





      {!isFacilityManager && (
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
          {numberItems.map((eachitems, eachIndex) => (
            <div key={eachIndex + 1 + ''} style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: eachIndex === 0 ? '#fae8fb' : eachIndex === 1 ? '#fad9cc' : eachIndex === 2 ? '#fee9c0' : '#f5f3fe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src={`/media/svg/dashboard/${eachitems.icon}.png`} alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>{eachitems.name}</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {impact?.[0]?.[eachitems.value]?.toFixed(
                      [
                        'collectionPoints',
                        'diversionFacilities',
                        'wasteDiverters',
                        'lifeImpacted',
                      ].includes(eachitems.value)
                        ? 0
                        : 2
                    ) || ''}
                    {eachitems.value === 'totalEnergySavings'
                      ? ' KwH'
                      : eachitems.value === 'totalWaterSavings'
                        ? ' Liter'
                        : eachitems.value === 'totalTreeSavings'
                          ? ' Nos'
                          : [
                            'collectionPoints',
                            'diversionFacilities',
                            'wasteDiverters',
                            'lifeImpacted',
                            'wastage',
                          ].includes(eachitems.value)
                            ? ''
                            : ' kg'
                    }
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}




      {/* show this when faclity master is logged in */}
      {isFacilityManager && (
        <div className='row g-3 g-xl-8'>
          {numberItems.map((eachitems, eachIndex) => (
            <div key={eachIndex + 1 + ''} className='col-xl-3'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                img={eachitems.icon}
                color={eachitems.color || 'warning'}
                iconColor='primary'
                title={`
          ${impact1?.[0]?.pickupPointImpacts?.[0]?.[eachitems.value]?.toFixed(
                  [
                    'collectionPoints',
                    'diversionFacilities',
                    'wasteDiverters',
                    'lifeImpacted',
                  ].includes(eachitems.value)
                    ? 0
                    : 2
                ) || '0'}
          ${eachitems.value === 'totalEnergySavings'
                    ? 'KwH'
                    : eachitems.value === 'totalWaterSavings'
                      ? 'Liter'
                      : eachitems.value === 'totalTreeSavings'
                        ? 'Nos'
                        : [
                          'collectionPoints',
                          'diversionFacilities',
                          'wasteDiverters',
                          'lifeImpacted',
                          'wastage',
                        ].includes(eachitems.value)
                          ? ''
                          : ' kg'
                  }
        `}
                description={eachitems.name}
              />
            </div>
          ))}
        </div>
      )}


      {!isFacilityManager && (
        <div className='row g-3 g-xl-8'>
          <div className='col-xl-6'>
            {<ChartsWidget3 data={data1} name='Lives Impacted' className='card-xl-stretch mb-xl-8' />}
          </div>
          <div className='col-xl-6'>
            <ChartsWidget3 data={data2} name='Income Generated' className='card-xl-stretch mb-xl-8' />
          </div>
        </div>
      )}




      {!isFacilityManager && (
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-4'>
            <MixedWidget7
              data={impact?.[0]?.genderRatio || {}}
              title='Gender Equity'
              className='card-xl-stretch mb-xl-8'
              chartColor='success'
              chartHeight='200px'
            />
          </div>
        </div>
      )}
      <div>

        <div className="card">
          <div className="card-body">
            <UsersListHeader
              showResetButton={true}
              initialApi='collect/orders'
              searchElements={searchElements}
              showDownload
              downloadViewLabel='Certificate'
              placeholder='Search Category'
            />
          </div>
        </div>


        <br />




        {/* <div className='row g-3 g-xl-8'>
          {numberItems.map((eachitems, eachIndex) => (
            <div key={eachIndex + 1 + ''} className='col-xl-3'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8'
                // svgIcon={`/media/svg/dashboard/co2.png`}
                img={eachitems.icon}
                color={eachitems.color || 'warning'}
                iconColor='primary'
                // title={eachitems.value}
                title={`
             ${(response?.savings && response?.[eachitems.value_two]?.toFixed(2)) || ''}
             ${eachitems.value === 'totalEnergySavings'
                    ? 'KwH'
                    : eachitems.value === 'totalWaterSavings'
                      ? 'Liter'
                      : eachitems.value === 'totalTreeSavings'
                        ? 'Nos'
                        : ' kg'
                  }
           `}
                // titleColor='primary'
                description={eachitems.name}
              // descriptionColor='primary'
              />
            </div>
          ))}
        </div> */}




        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
          {numberItems.map((eachitems, eachIndex) => (
            <div key={eachIndex + 1 + ''} style={{
              margin: '10px',
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              flex: 1
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: eachIndex === 0 ? '#fae8fb' : eachIndex === 1 ? '#fad9cc' : eachIndex === 2 ? '#fee9c0' : '#f5f3fe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#1a1a1a'
                }}>
                  <img src={`/media/svg/dashboard/${eachitems.icon}.png`} alt="" style={{ width: '27px', height: '27px' }}></img>
                </div>

                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '16px', fontWeight: '400' }}>{eachitems.name}</div>
                  <div style={{ fontSize: '24px', fontWeight: '700' }}>
                    {(response?.savings && response?.[eachitems.value_two]?.toFixed(2)) || ''}
                    {eachitems.value === 'totalEnergySavings'
                      ? ' KwH'
                      : eachitems.value === 'totalWaterSavings'
                        ? ' Liter'
                        : eachitems.value === 'totalTreeSavings'
                          ? ' Nos'
                          : ' kg'
                    }
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>



        <UsersTable initialApi='collect/orders' showPagination={true} columnProps={roleColumns} />

        {!isFacilityManager && (
          // <div className='card-header border-0 pt-5 mb-5'>
          //   <div className='card-title'>
          //     <div className='d-flex align-items-center'>
          //       <div className='d-flex flex-column align-items-start position-relative my-1 me-4'>
          //         <label className="mb-2" style={{ fontWeight: 600 }}>Start date</label>
          //         <input
          //           type='date'
          //           className='form-control form-control-solid'
          //           placeholder='Start date'
          //           value={startDate}
          //           onChange={(e) => setStartDate(e.target.value)}
          //           style={{ width: '250px', backgroundColor: '#f9f9f9' }}
          //         />
          //       </div>

          //       <div className='d-flex flex-column align-items-start position-relative my-1 me-4'>
          //         <label className="mb-2" style={{ fontWeight: 600 }}>End date</label>
          //         <input
          //           type='date'
          //           className='form-control form-control-solid'
          //           placeholder='End date'
          //           value={endDate}
          //           onChange={(e) => setEndDate(e.target.value)}
          //           style={{ width: '250px', backgroundColor: '#f9f9f9' }}
          //         />
          //       </div>

          //       <div className='d-flex align-items-center' style={{ marginTop: "25px" }}>

          //         <button
          //           type='button'
          //           className='btn btn-light me-3'
          //           onClick={handleReset}
          //         >
          //           Reset
          //         </button>

          //         <button
          //           style={{ backgroundColor: '#12B886' }}
          //           type='button'
          //           className='btn btn-primary fw-bold px-6 me-3'
          //           onClick={handleApply}
          //           disabled={loading || !startDate || !endDate}
          //         >
          //           {loading ? (
          //             <span className='spinner-border spinner-border-sm align-middle me-2'></span>
          //           ) : null}
          //           Apply
          //         </button>

          //         <button
          //           type='button'
          //           className='btn btn-success'
          //           onClick={handleCertificate}
          //           style={{ backgroundColor: 'black', color: 'white', fontWeight: 600 }}
          //           disabled={!startDate || !endDate}
          //         >
          //           Certificate
          //         </button>
          //       </div>
          //     </div>
          //   </div>
          // </div>
          <div className='card card-flush mb-5'>
            <div className='card-header border-0 pt-5 mb-5'>
              <div className='card-title pl-7'>
                <div className='d-flex align-items-center'>
                  <div className='d-flex flex-column align-items-start position-relative my-1 me-4'>
                    <label className='form-label fs-6 fw-bold'>Start date</label>
                    {/* <br /> */}
                    <DatePicker
                      customInput={
                        <input
                          style={{
                            backgroundColor: '#ffffff',
                            border: '1px solid #dddddd',
                            color: '#000000',
                          }}
                        />
                      }
                      placeholderText="Select start date"
                      className='form-control form-control-solid w-250px ps-14'
                      selected={startDate ? new Date(startDate) : null}
                      onChange={(date) => setStartDate(date ? date.toISOString().split('T')[0] : '')}
                    />
                  </div>
                  <div className='d-flex flex-column align-items-start position-relative my-1 me-4'>
                    <label className='form-label fs-6 fw-bold'>End date</label>
                    {/* <br /> */}
                    <DatePicker
                      customInput={
                        <input
                          style={{
                            backgroundColor: '#ffffff',
                            border: '1px solid #dddddd',
                            color: '#000000',
                          }}
                        />
                      }
                      placeholderText="Select end date"
                      className='form-control form-control-solid w-250px ps-14'
                      selected={endDate ? new Date(endDate) : null}
                      onChange={(date) => setEndDate(date ? date.toISOString().split('T')[0] : '')}
                    />
                  </div>
                  <div className='d-flex align-items-center' style={{ marginTop: "25px" }}>
                    <button
                      type='button'
                      className='btn btn-light me-3'
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                    <button
                      // style={{ backgroundColor: '#ed6e43' }}
                      type='button'
                      className='btn btn-primary fw-bold px-6 me-3'
                      onClick={handleApply}
                      disabled={loading || !startDate || !endDate}
                    >
                      {loading ? (
                        <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                      ) : null}
                      Apply
                    </button>
                    <button
                      type='button'
                      className='btn btn-success'
                      onClick={handleCertificate}
                      style={{ backgroundColor: 'black', color: 'white', fontWeight: 600 }}
                      disabled={!startDate || !endDate}
                    >
                      Certificate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <UserEditModal formName='ImpactModalCertForm' />
      </div>
    </KTCard>
  )
}

const ReportsMenu = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'impact' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <Menu />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { ReportsMenu }
